import React from 'react'
import LxHeader from '@/components/LxHeader/One'
// import { Link } from 'react-router-dom'
import styles from './index.module.scss'
import {LeftOutlined, RightOutlined} from "@ant-design/icons"
import {getDynamicApi} from '@/api'
import {Spin} from "antd"

class RecruitmentNewsDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showList: [],
            showIndex: 0,
            detail: '',
            loading: false,
        }
    }

    componentDidMount() {
        console.log(window.location.search)
        let search = window.location.search
        getDynamicApi({dynamicKey: 0, pageSize: 9999}).then(res => {
            let showList = (res && res.data && res.data.dynamicDetail) || []
            let showIndex = search ? search.split("=")[1] * 1 : 0

            this.getDetail(showList[showIndex].key);

            this.setState({
                showList: showList,
                showIndex: showIndex,
            })
        })
    }

    changeTxt = (flag) => {
        let {showList, showIndex} = this.state;
        if(flag === "pre"){
            showIndex = Number(showIndex) - 1
        } else {
            showIndex = Number(showIndex) + 1
        }

        this.getDetail(showList[showIndex].key);

        this.setState({
            showIndex
        })
    }

    getDetail = (key) => {
        this.setState({loading: true});
        getDynamicApi({dynamicKey: 0, newsKey: key}).then(res => {
            this.setState({
                detail: (res && res.data && res.data.dynamicDetail) || '',
                loading: false,
            })
        }).catch(() => {
            this.setState({
                loading: false,
            })
        })
    }

    render() {
        const {showList, showIndex, detail, loading} = this.state;
        return (
            <>
                <LxHeader></LxHeader>
                <div className={styles.newsWrapDetail}>
                    <Spin spinning={loading}>
                    <div className="newsDetailWrap">
                        <div className="detailTitle">
                            <span style={{cursor: "pointer"}} onClick={()=>{
                                this.props.history.go(-1)
                            }}>招聘公示</span>&nbsp;&nbsp;/&nbsp;&nbsp;{detail.title}
                        </div>
                        <div className="detailWrap">
                            <div className="detailWrapTitle">{detail.title}</div>
                            <div className="detailWrapTime">{detail.times}</div>
                            <div className="detailWrapText" dangerouslySetInnerHTML={{__html: detail.detail}}></div>
                            <div className="bottom-btn-wrap">
                                <div className={"btn-item " + (showIndex === 0 ? "disabled" : "")} onClick={() => {
                                    this.changeTxt("pre")
                                }}><LeftOutlined/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上一篇
                                </div>
                                <div className={"btn-item " + ((showIndex === (showList.length - 1) ? "disabled" : ""))} onClick={() => {
                                    this.changeTxt("next")
                                }}>下一篇&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<RightOutlined/></div>
                            </div>
                        </div>
                    </div>
                    </Spin>
                </div>
            </>
        )
    }
}

export default RecruitmentNewsDetail;
